/* CRO interactions only. Shopify's standard web pixel events own ecommerce conversions. */
(() => {
  if (window.LegalTracking) return;

  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
    } catch (_) { /* Pixel publication remains available without the optional GTM bridge. */ }
  }

  const allowedFields = new Set([
    'surface', 'cart_surface', 'format', 'intensity', 'tab', 'product_id', 'variant_id',
    'collection_card_index', 'cups', 'quantity', 'cart_item_count',
    'purchase_type', 'selling_plan_id', 'sort_by', 'intensity_sort',
    'filter_count', 'products_visible', 'failure_reason',
    'quantity_before', 'variant', 'answer', 'step',
  ]);

  const clean = (details) => {
    const result = {};
    Object.entries(details || {}).forEach(([key, value]) => {
      if (!allowedFields.has(key) || value === undefined || value === null || value === '') return;
      if (typeof value === 'number' && Number.isFinite(value)) result[key] = value;
      if (typeof value === 'boolean') result[key] = value;
      if (typeof value === 'string' && !value.includes('@')) result[key] = value.slice(0, 100);
    });
    return result;
  };

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (_) {
      return false;
    }
  };

  const track = (name, details = {}) => {
    if (!/^[a-z][a-z0-9_]*$/.test(name)) return;
    const eventData = {
      event_version: 1,
      event_id: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      page_type: document.body?.dataset.pageType || '',
      ...clean(details),
    };

    // Custom customer events are delivered to Shopify app and custom pixels.
    // Pixel subscribers handle consent; no GA4/Meta standard event is emitted here.
    try {
      const publication = window.Shopify?.analytics?.publish?.(`legal_cro:${name}`, eventData);
      publication?.catch?.(() => {});
    } catch (_) { /* An unavailable pixel must never block shopping. */ }

    // Keep the existing GTM dataLayer contract, but only after analytics consent.
    if (analyticsAllowed()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `legal_${name}`, ...eventData });
    }
  };

  window.LegalTracking = { track };

  document.addEventListener('click', (event) => {
    const megaVideoLink = event.target.closest('[data-legal-cro-mega-action]');
    if (megaVideoLink) {
      track('mega_menu_video_cta_click', { surface: 'mega_menu_video', tab: megaVideoLink.dataset.legalCroMegaAction });
      return;
    }

    const heroLink = event.target.closest('[data-legal-cro-hero-format]');
    if (heroLink) {
      track('hero_format_click', { surface: 'home_hero', format: heroLink.dataset.legalCroHeroFormat });
      return;
    }

    const recommendation = event.target.closest('[data-legal-recommendation-option]:not([hidden])');
    if (recommendation && event.target.closest('.legal-home-recommendation__details')) {
      track('finder_product_open', {
        surface: 'home_finder',
        product_id: recommendation.dataset.productId,
        format: recommendation.dataset.format,
        intensity: recommendation.dataset.intensity,
      });
    }
  });

  document.addEventListener('change', (event) => {
    const planField = event.target.closest('input[name="selling_plan"], select[name="selling_plan"]');
    if (!planField || !planField.closest('.legal-product-detail')) return;
    const sellingPlanId = planField.value && planField.value !== '0' ? planField.value : '';
    track('pdp_purchase_option_selected', {
      surface: 'pdp',
      product_id: document.body?.dataset.productId,
      purchase_type: sellingPlanId ? 'subscription' : 'one_time',
      selling_plan_id: sellingPlanId || undefined,
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-legal-newsletter-success]').forEach((message) => {
      track('newsletter_signup_success', { surface: message.dataset.legalNewsletterSuccess || 'home' });
    });

    const subscriptionOffer = document.querySelector('.legal-product-detail .legal-purchase-options');
    if (subscriptionOffer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        track('pdp_subscription_offer_viewed', {
          surface: 'pdp',
          product_id: document.body.dataset.productId,
        });
      }, { threshold: 0.25 });
      observer.observe(subscriptionOffer);
    }
  });
})();
